import { SCOPE_KEYS, SCOPE_KEY_LABELS, type RoleScope, type ScopeKey } from '../../domain/access';
import { ChipInput } from '../common/ChipInput';

interface ScopeEditorProps {
  value: RoleScope[];
  onChange: (next: RoleScope[]) => void;
  disabled?: boolean;
  idPrefix: string;
}

/** Les cinq dimensions de périmètre d'un rôle. Une dimension sans valeur = pas de restriction. */
export const ScopeEditor = ({ value, onChange, disabled, idPrefix }: ScopeEditorProps) => {
  const valuesFor = (key: ScopeKey) => value.find(scope => scope.key === key)?.values ?? [];

  const setValues = (key: ScopeKey, values: string[]) => {
    const others = value.filter(scope => scope.key !== key);
    onChange(values.length > 0 ? [...others, { key, values }] : others);
  };

  return (
    <div className="flex flex-col gap-2">
      {SCOPE_KEYS.map(key => (
        <div key={key} className="flex flex-col gap-1">
          <label htmlFor={`${idPrefix}-${key}`} className="text-[11px] text-zinc-600">
            {SCOPE_KEY_LABELS[key]}
          </label>
          <ChipInput
            id={`${idPrefix}-${key}`}
            values={valuesFor(key)}
            onChange={values => setValues(key, values)}
            disabled={disabled}
            placeholder="Toutes les valeurs"
          />
        </div>
      ))}
      <p className="text-[11px] text-zinc-500">Aucune valeur = tout le compte sur cette dimension.</p>
    </div>
  );
};
